import AddUserGroup from "./add";
import EditUserGroup from "./edit";
import { UserGroupListItem } from "api/interfaces/userInterface.interface";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";

type Props = {
  isAddModal: boolean;
  isEditModal: string | null;
  columns: TableColumnsType<UserGroupListItem>;
  data: Array<UserGroupListItem>;
  onModal: (type: string) => void;
  onChangePage: (page: number, totalRows: number) => void;
  initialPending: boolean;
  paginationInfo: BasePagination;
  onSuccessDelete: () => void;
};

export default function UserGroupPresenter(props: Props): JSX.Element {
  return (
    <>
      <CommonTable
        columns={props.columns}
        dataSource={props.data}
        queryInfo={props.paginationInfo}
        onChangePage={props.onChangePage}
        loading={props.initialPending}
        rowKey="id"
      />
      {props.isAddModal && (
        <AddUserGroup onModal={() => props.onModal("add")} />
      )}
      {props.isEditModal !== null && (
        <EditUserGroup
          groupId={props.isEditModal}
          onModal={() => props.onModal("edit")}
          onSuccessDelete={props.onSuccessDelete}
        />
      )}
    </>
  );
}
